import React, { useState } from "react";
import { FileText } from "lucide-react";

export default function Tramites() {
  const currentYear = new Date().getFullYear();
  const [anio, setAnio] = useState(currentYear);
  const [mes, setMes] = useState(new Date().getMonth() + 1);

  const anios = Array.from({ length: 10 }, (_, i) => currentYear - i);
  const meses = [
    { value: 1, nombre: "Enero" },
    { value: 2, nombre: "Febrero" },
    { value: 3, nombre: "Marzo" },
    { value: 4, nombre: "Abril" },
    { value: 5, nombre: "Mayo" },
    { value: 6, nombre: "Junio" },
    { value: 7, nombre: "Julio" },
    { value: 8, nombre: "Agosto" },
    { value: 9, nombre: "Septiembre" },
    { value: 10, nombre: "Octubre" },
    { value: 11, nombre: "Noviembre" },
    { value: 12, nombre: "Diciembre" },
  ];

  const handleDescargarCarta = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;

      const response = await fetch(
        `/api/tramites/carta-laboral/${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Error de backend:", errorText);
        throw new Error("Error al generar la carta laboral");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Carta_Laboral_${user?.nombre || "empleado"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log("✅ Carta laboral descargada correctamente");
    } catch (error) {
      console.error("🚨 Error general en descarga:", error);
      alert("No se pudo descargar la carta laboral: " + error.message);
    }
  };

  const handleDescargarDesprendible = async () => {
    if (!mes || !anio) {
      alert("Por favor, selecciona un mes y un año para descargar el desprendible.");
      return;
    }

    // Formatear el mes a dos dígitos (ej: 01, 02, 11)
    const mesFormateado = mes.toString().padStart(2, '0');
    // Crear una fecha válida para el primer día del mes seleccionado
    const fechaDesprendible = `${anio}-${mesFormateado}-01`;

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;

      console.log(`Solicitando desprendible de pago para el usuario ID: ${userId}`);
      const response = await fetch(
        `/api/tramites/desprendible/${userId}?fecha=${fechaDesprendible}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Error de backend:", errorText);
        throw new Error("Error al generar el desprendible de pago");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Desprendible_Pago_${user?.nombre || "empleado"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log("✅ Desprendible descargado correctamente");
    } catch (error) {
      console.error("🚨 Error general en descarga:", error);
      alert("No se pudo descargar el desprendible de pago: " + error.message);
    }
  };

  return (
    <div className="relative p-6">
      <h2 className="text-2xl font-bold mb-4">📂 Trámites</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {/* Carta Laboral */}
        <div className="max-w-sm mx-auto bg-cart shadow-lg rounded-2xl p-6 text-center border border-gray-100 hover:shadow-xl transition">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <FileText className="text-blue-600 w-8 h-8" />
            </div>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Carta Laboral
          </h2>

          <button
            onClick={handleDescargarCarta}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Descargar
          </button>
        </div>

        {/* Desprendible de Pago */}
        <div className="max-w-sm mx-auto bg-cart shadow-lg rounded-2xl p-6 text-center border border-gray-100 hover:shadow-xl transition">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <FileText className="text-blue-600 w-8 h-8" />
            </div>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Desprendible de pago
          </h2>

          <div className="flex gap-2 mb-4">
            <select
              value={mes}
              onChange={(e) => setMes(e.target.value)}
              className="w-full border rounded p-2"
            >
              {meses.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.nombre}
                </option>
              ))}
            </select>
            <select
              value={anio}
              onChange={(e) => setAnio(e.target.value)}
              className="w-full border rounded p-2"
            >
              {anios.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={handleDescargarDesprendible}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Descargar
          </button>
        </div>
      </div>
    </div>
  );
}

